import { render, staticRenderFns } from "./salaryTemplate.vue?vue&type=template&id=67b62fea&scoped=true&"
import script from "./salaryTemplate.vue?vue&type=script&lang=js&"
export * from "./salaryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./salaryTemplate.vue?vue&type=style&index=0&id=67b62fea&scoped=true&lang=css&"
import style1 from "./salaryTemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b62fea",
  null
  
)

export default component.exports